import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

const CREATE_EVENT_V3 = gql`
  mutation CreateEventV3($input: CreateEventV3Input!) {
    createEventV3(input: $input) {
      id
      name
      start_date
    }
  }
`;

export function useCreateEventV3() {
  const [createEventMutation] = useMutation(CREATE_EVENT_V3);

  const createEventV3 = useCallback(
    async (input) => {
      const response = await createEventMutation({
        variables: { input },
      });
      return response;
    },
    [createEventMutation]
  );

  return createEventV3;
}
